/*
 * The DevExtreme license key. It is a signed hash, not a secret.
 *
 * Shared by main.ts and test-setup.ts. A test run never executes main.ts, so without the
 * second call every spec that renders a DevExtreme widget logs W0019 (trial version) and
 * W0021 (license verification failed).
 *
 * Not named devextreme-license.ts: that is the file the devextreme-license tool
 * generates, and .gitignore excludes it.
 */
export const DEVEXTREME_LICENSE_KEY =
	'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjEzY2YwNDAxLTU5M2ItNDVkZS04MTg1LThlMTI3YjdmN2U0ZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.ZFOw4NA+/cB9N1KqTx+gs4fjDY1L4IxWNLsIGZJz2pOlMmQw9qMaxIKPr53Hh6oPkAd1LGSe5+jT3hUS30xKogquun+FpHjXmtP7FN5Dm3IDtqllnyu3hDHjLBrbzsyzPNtm6Q==';
